import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionReset } from '../types';

const reset: IActionReset = action(state => {
  const { triageRequests, pagination } = initStore;

  state.triageRequests = triageRequests;
  state.pagination = pagination;
});

export default reset;
